import { toLowerCaseDay } from '@utils/dates'
import { twJoin } from 'tailwind-merge'

export const dashedBorders =
  'border-t border-dashed border-neutral-300 first:border-t-0'
export const col = (date: DateTime) => `grid-in-${toLowerCaseDay(date)}`

export const weekGridClasses = (weekStartsOn: 'sunday' | 'monday') =>
  twJoin(
    'grid',
    {
      monday: 'grid-areas-entries-mon-start grid-cols-entries-mon-start',
      sunday: 'grid-areas-entries grid-cols-entries',
    }[weekStartsOn],
  )
